// @flow
import { Map } from "immutable";

export const uploadFileErrorSelector = (state: Map<string, any>) => {
  return state.getIn(["upload", "error"]);
};



// WEBPACK FOOTER //
// ./src/features/upload/store/uploadSelectors.js